// in src/Menu.js
import React, { createElement } from 'react';
import { connect } from 'react-redux';
import { Responsive, MenuItemLink, getResources } from 'react-admin';
import { withRouter, Link } from 'react-router-dom';
import Cookies from 'universal-cookie';

import AccountBox from '@material-ui/icons/AccountBox';

import MenuItem from '@material-ui/core/MenuItem';
//import Responsive from '../layout/Responsive';
import {userCookieName } from './AppConfig'

const Menu = ({ resources, onMenuClick, logout, permissions }) => {
    const cookies = new Cookies();
    const userId = cookies.get(userCookieName)
    const user_profile_link = "/user_profile/"+cookies.get(userCookieName)+"/edit"
    let user_profile = <MenuItem>
            <AccountBox />
      <Link to={user_profile_link}>User Profile</Link></MenuItem>
    user_profile = <MenuItemLink
        key="user_profile"
        to={user_profile_link}
        primaryText="User Profile"
        leftIcon={createElement(AccountBox)}
    />
    return <div>
        {resources.map(resource => {
            if(resource.hasList && resource.options.noMenuItem === undefined) {
              return (<MenuItemLink
                  key={resource.name}
                  to={`/${resource.name}`}
                  primaryText={ ( resource.options && resource.options.label ) || resource.name}
                  leftIcon={createElement(resource.icon)}
                  onClick={onMenuClick}
              />)
            } else {
              return null
            }
          }
        )}
        <Responsive
            small={logout}
            medium={null} // Pass null to render nothing on larger devices
        />
        { userId && userId !== 'public' ? user_profile : null }
    </div>
};

const mapStateToProps = state => ({
    resources: getResources(state),
});

export default withRouter(connect(mapStateToProps)(Menu));

//{resources.length < 4 ? <MenuItem>Thanks for Participating!</MenuItem> : null}
